import React, { Component } from 'react';
import tableDragger from 'table-dragger';
import Modal from 'react-responsive-modal';
import swal from 'sweetalert';
import {baseUrl} from '../../Comman/apiEndPoints';
import imageCompression from 'browser-image-compression';
import { withNamespaces } from 'react-i18next';
import InputWithExtra from '../../Comman/components/InputWithExtra';

// import { Editor } from "react-draft-wysiwyg";
// import { EditorState } from "draft-js";
// import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";

const options = {
    maxSizeMB: 2.0,          // (default: Number.POSITIVE_INFINITY)
    maxWidthOrHeight: 600,   // compressedFile will scale down by ratio to a point that width or height is smaller than maxWidthOrHeight (default: undefined)
    useWebWorker: true,      // optional, use multi-thread web worker, fallback to run in main-thread (default: true)
    maxIteration: 10        // optional, max number of iteration to compress the image (default: 10)
}
const sleep = (milliseconds) => {
    return new Promise(resolve => setTimeout(resolve, milliseconds))
}
var result_arr = [];
class CarouselSettingComponent extends Component { 
    constructor(props) {
        super(props);
        this.state = {
            // editorState : EditorState.createEmpty(),
            openModal: false,
            image: null,
            isEdit : false,
            id : 0,
            newCarouselData : {
                HeaderText : '',
                DescriptionText : '',
                PageLogo : ''
            }
        }
        this.handleInput = this.handleInput.bind(this);
        this.saveSequence = this.saveSequence.bind(this);
    }

    componentDidUpdate() {
        let self = this;
        var el = document.getElementById('table');
        if (el.rows.length > 1) {
            var dragger = tableDragger(el, {
                mode: 'row',
                dragHandler: '.handle',
                onlyBody: true,
                animation: 100
            });
            dragger.on('drop', function (oldIndex, newIndex) {
                console.log("oldIndex", oldIndex);
                console.log("newIndex", newIndex);
                if(self.props.CarouselSettingDetails.carouselList.length > 0){
                    var arr = self.props.CarouselSettingDetails.carouselList;
                    var sortedArr = self.array_move(arr,oldIndex-1,newIndex-1);
                    
                    result_arr = sortedArr.filter((item,index) => {
                        if(item){
                            item.PageSequence = index+1;
                        }
                        return sortedArr;       
                    });
                    console.log("result_arr",result_arr);
                }
            });
        }
    }
    array_move(arr, old_index, new_index) {
        if (new_index >= arr.length) {
            var k = new_index - arr.length + 1;
            while (k--) {
                arr.push(undefined);
            }
        }
        arr.splice(new_index, 0, arr.splice(old_index, 1)[0]);
        return arr;
    };
    componentWillReceiveProps(nextProps){
       console.log("next",nextProps);
        if(nextProps.CarouselSettingDetails.message != this.props.CarouselSettingDetails.message){
            if(nextProps.CarouselSettingDetails.statusCode==200){
                swal(nextProps.CarouselSettingDetails.message, {
                    icon: "success",
                  });
               this.props.getCarouselSetting();
            }
        }
    }
    openModal = () => {
        this.setState({ openModal: true })
    }
    closeModal = () => {
        this.setState({ openModal: false })
        this.setState({ isEdit : false, image: null })
        this.setState({
            newCarouselData : {
                HeaderText : '',
                DescriptionText : '',
                PageLogo : ''
            }
        })
    }
    handleInput=(e)=>{
        let value = e.target.value;
        let name = e.target.name;
        this.setState( prevState => ({ newCarouselData : 
          {...prevState.newCarouselData, [name]: value}
         }),  )
        // sleep(3000).then(() => {
        //     console.log("setstate",this.state);
        // })
    }
    imageUpload = (event) => {
        let file = event.target.files[0];
        var self=this;
        let reader = new FileReader();
        imageCompression(file, options)
        .then(function (compressedFile) {
            self.setState({ image : compressedFile})
            reader.readAsDataURL(compressedFile); 
            reader.onloadend = function() {
                self.setState(prevState => ({ newCarouselData : 
                    {...prevState.newCarouselData,
                        PageLogo: reader.result,
                    },
                    }))
            }
        })
        .catch(function (error) {
            console.log(error);
        });
        // let reader = new FileReader();
        // reader.onload = () => {
        //     this.setState({ image : file})
        //     this.setState( prevState => ({ newCarouselData : 
        //         {...prevState.newCarouselData, PageLogo : reader.result}
        //     }))
        //   };
        //   reader.readAsDataURL(file);
      }
    delete(id){
        const { t } = this.props;
        console.log("data",id);
        swal({
            title: `${t('Carousel Setting.Are you sure you want to delete this data')}`,
            text: `${t('Carousel Setting.Once deleted, you will not be able to recover this data')}`,
            icon: "warning",
            buttons: true,
            dangerMode: true,
          })
          .then((willDelete) => {
            if (willDelete) {
                this.props.deleteCarouselItem(id);
            } else {
              swal(`${t('Carousel Setting.Data not deleted')}`);
            }
          });
    }
    add = () => {
        const { t } = this.props;
        if(this.state.newCarouselData.HeaderText.length > 0 && this.state.newCarouselData.DescriptionText.length > 0 &&
            this.state.image){
                const formData = new FormData();
                formData.append('HeaderText',this.state.newCarouselData.HeaderText)
                formData.append('DescriptionText',this.state.newCarouselData.DescriptionText)
                formData.append('PageLogo',this.state.image)
                formData.append('ImageName',this.state.image.name)
                this.props.addCarousel(formData);
                this.setState({ openModal: false,  image: null})
                this.setState({
                    newCarouselData : {
                        HeaderText : '',
                        DescriptionText : '',
                        PageLogo : ''
                    }
                })
        }
        else{
            swal(`${t('Carousel Setting.Please Enter Header, Description and image')}`);
        }
    }
    update = () =>{
        const { t } = this.props;
        const formData = new FormData();
        if(this.state.image){
            formData.append('PageLogo',this.state.image)
            formData.append('ImageName',this.state.image.name)
        }
        else{
            formData.append('PageLogo',null)
            formData.append('ImageName',null)
        }
        formData.append('Id', this.state.id)
        formData.append('HeaderText',this.state.newCarouselData.HeaderText)
        formData.append('DescriptionText',this.state.newCarouselData.DescriptionText)

        if(this.state.id > 0 && this.state.newCarouselData.HeaderText.length > 0 && this.state.newCarouselData.DescriptionText.length > 0
            && this.state.newCarouselData.PageLogo){
                this.props.updateCarousel(formData);
                this.setState({ 
                    isEdit: false,
                    image: null,
                    id : 0
                })
                this.setState({
                    newCarouselData : {
                        HeaderText : '',
                        DescriptionText : '',
                        PageLogo : ''
                    }
                })
        }
        else{
            swal(`${t('Carousel Setting.Please Enter Header, Description and image')}`);
        }
    }
    openEditModal = (item) => {
        this.setState({
            isEdit : true,
            id : item.Id,
            // image : item.PageLogo,
            newCarouselData : {
                HeaderText : item.HeaderText,
                DescriptionText : item.DescriptionText,
                PageLogo : item.PageLogo
            }
        })
    }
    deleteImage = () =>{
        this.setState({ image: null})
        this.setState( prevState => ({ newCarouselData : 
            {...prevState.newCarouselData, PageLogo : ''}
        }))
        sleep(3000).then(() => {
            console.log("setstate1",this.state);
        })
      }
      saveSequence(){
        let prevArr = this.props.CarouselSettingDetails.carouselList;
        let requestPayload = result_arr.length ? result_arr : prevArr;
        this.props.saveSequenceList(requestPayload);
      }
    //   onEditorStateChange = (editorState) => {
    //     this.setState({
    //       editorState : editorState
    //     });
    //     console.log("setstate1",this.state);
    //   };
    render() {
        const { t } = this.props;
        return (
            <div className="container carousel-page">
                <div className="progressbar-heading grids-heading">
                    <h2>{t('Carousel Setting.Carousel Setting')}</h2>
                    <div className="text-right m-b-25 ">
                        <button type="button" className="btn btn-primary edit-carousel"
                            onClick={this.openModal}>{t('Carousel Setting.Add')}</button>
                        <button type="button" className="btn btn-primary"
                            onClick={this.saveSequence}>{t('Carousel Setting.Save Sequence')}</button>
                    </div>
                </div>
                <div className="overflow-scroll">
                    <table id="table">
                        <thead>
                            <tr>
                                <th>{t('Carousel Setting.Page Sequence')}</th>
                                <th>{t('Carousel Setting.Header Text')}</th>
                                <th>{t('Carousel Setting.Description Text')}</th>
                                <th>{t('Carousel Setting.Image for Carousel')}</th>
                                <th>{t('Carousel Setting.Action')}</th>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                (this.props.CarouselSettingDetails && this.props.CarouselSettingDetails.carouselList.length) ? 
                                this.props.CarouselSettingDetails.carouselList.map(item =>
                                    <tr key={item.Id}>
                                        <td className="handle width-13">{item.PageSequence}</td>
                                        <td className="handle width-20">{item.HeaderText}</td>
                                        <td className="handle width-47">{item.DescriptionText}</td>
                                        <td className="handle width-20"><img src={item.PageLogo} width="80px"></img></td>
                                        <td className="handle width-20">
                                            <button type="button" className="btn btn-primary edit-carousel"
                                                onClick={this.openEditModal.bind(this,item)}>{t('Alarm Setting.Edit')}</button>
                                            <button type="button" className="btn btn-primary"
                                                onClick={this.delete.bind(this,item.Id)}>{t('First_Responder.Delete')}</button>
                                        </td>
                                    </tr>
                                ) : 
                                <p>{t('Carousel Setting.Carousel List not found')}</p>
                            }
                        </tbody>
                    </table>
                </div>
                <Modal open={this.state.openModal} onClose={this.closeModal} center>
                    <div className="modal1 alarmsetmodal">
                        <div className="progressbar-heading grids-heading">
                            <h2>{t('Carousel Setting.Add Carousel')}</h2>
                        </div>
                        <div className="forms add-device setting-panel">
                            <div className="form-three widget-shadow">
                                <div className=" panel-body-inputin">
                                    <form className="form-horizontal modalForm">
                                        {/* <div className="form-group">
                                            <label className="col-sm-3 control-label">
                                                Page Sequence
                                            </label>
                                            <div className="col-sm-9">
                                                <input
                                                    type="number"
                                                    id="PageSequence"
                                                    name={'PageSequence'}
                                                    value={this.state.newCarouselData.PageSequence}
                                                    className="form-control1"
                                                    onChange={this.handleInput}
                                                />
                                            </div>
                                        </div> */}
                                        <div className="form-group">
                                            <label className="col-sm-3 control-label">{t('Carousel Setting.Header Text')}</label>
                                            <div className="col-sm-9">
                                                <input
                                                    type="text"
                                                    id="HeaderText"
                                                    name={'HeaderText'}
                                                    value={this.state.newCarouselData.HeaderText}
                                                    className="form-control1"
                                                    onChange={this.handleInput}
                                                />
                                            </div>
                                        </div>
                                        <div className="form-group">
                                            <label className="col-sm-3 control-label">{t('Carousel Setting.Description Text')}</label>
                                            <div className="col-sm-9">
                                                <textarea rows="5" id="DescriptionText" name={'DescriptionText'} className="form-control1"
                                                    value={this.state.newCarouselData.DescriptionText} onChange={this.handleInput}></textarea>
                                            </div>
                                        </div>
                                        <div className="form-group">
                                            <label className="col-sm-3 control-label">{t('Carousel Setting.Upload Image for Carousel')}</label>
                                            <div className="col-sm-9 image-width-100">
                                                <img src={this.state.newCarouselData.PageLogo}
                                                    className={ this.state.newCarouselData.PageLogo ? "image-logo" : '' } />
                                                <input type='file' accept="image/*" name={'PageLogo'} onChange={this.imageUpload}
                                                    id="addImageUpload" className="hide_input_type_file" />
                                                <label for="addImageUpload" className="choose-file-btn" style={{color : 'black'}}>{t('Notification Setting.Select Image')}</label>
                                            </div>
                                        </div>
                                        <div className="form-group"> 
                                            <div className="col-sm-offset-5 col-sm-6">      
                                            <p>
                                            <button 
                                                type="button"
                                                className="btn btn-primary general-btn" 
                                                onClick={this.add}
                                                >
                                                {t('Alarm Setting.Save')}
                                            </button>
                                            </p>
                                            </div>
                                        </div>
                                    </form></div></div></div>
                    </div>
                </Modal>
                <Modal open={this.state.isEdit} onClose={this.closeModal} center>
                <div className="modal1 alarmsetmodal">
                    <div className="progressbar-heading grids-heading">
                        <h2>{t('Carousel Setting.Edit Carousel Setting')}</h2>
                    </div>
                </div>
                <div className="forms add-device setting-panel">
                            <div className="form-three widget-shadow">
                                <div className=" panel-body-inputin">
                                    <form className="form-horizontal modalForm">
                                        <div className="form-group">
                                            <label className="col-sm-3 control-label">{t('Carousel Setting.Header Text')}</label>
                                            <div className="col-sm-9">
                                                <InputWithExtra
                                                    type="text"
                                                    id="HeaderText"
                                                    name={'HeaderText'}
                                                    value={this.state.newCarouselData.HeaderText}
                                                    className="form-control1 FR-edit-details"
                                                    onChange={this.handleInput}
                                                />
                                            </div>
                                        </div>
                                        <div className="form-group">
                                            <label className="col-sm-3 control-label">{t('Carousel Setting.Description Text')}</label>
                                            <div className="col-sm-9">
                                                <InputWithExtra type="text" id="DescriptionText" name={'DescriptionText'} className="form-control1 FR-edit-details"
                                                    value={this.state.newCarouselData.DescriptionText} onChange={this.handleInput} />
                                            </div>
                                        </div>
                                        <div className="form-group">
                                            <label className="col-sm-3 control-label">{t('Carousel Setting.Image for Carousel')}</label>
                                            <div className="col-sm-9">
                                                    {   this.state.newCarouselData.PageLogo ?
                                                        <div>
                                                        <img src={this.state.newCarouselData.PageLogo} width="300px" height="auto" /> 
                                                        <button type="button" className="btn btn-primary del-img" onClick={this.deleteImage}>{t('Carousel Setting.Delete Image')}</button>
                                                        </div>
                                                        :
                                                        <div>
                                                            <input type='file' accept="image/*" name={'PageLogo'} onChange={this.imageUpload} 
                                                                id="editImageUpload" className="hide_input_type_file"/>
                                                            <label for="editImageUpload" className="choose-file-btn" style={{color : 'black'}}>{t('Notification Setting.Select Image')}</label>
                                                            {/* <img src={this.state.newCarouselData.PageLogo}
                                                            className={ this.state.newCarouselData.PageLogo ? "image-logo" : '' } /> */}
                                                        </div>
                                                    }
                                                
                                            </div>
                                        </div>
                                        <div className="form-group"> 
                                            <div className="col-sm-offset-5 col-sm-6">      
                                            <p>
                                            <button 
                                                type="button"
                                                className="btn btn-primary general-btn" 
                                                onClick={this.update}
                                                >
                                                {t('Alarm Setting.Save')}
                                            </button>
                                            </p>
                                            </div>
                                        </div>
                                    </form></div></div></div>
                </Modal>
                {/* <Editor
          editorState={this.state.editorState}
          onEditorStateChange={this.onEditorStateChange}
        /> */}
            </div>
        )
    }
}
export default withNamespaces()(CarouselSettingComponent);